module.exports = __webpack_public_path__ + "img/larrykingbetter.3311032d.png";